"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatToggle = void 0;
var _reactIcons = require("@100mslive/react-icons");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _useSidepane = require("../AppData/useSidepane");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ChatToggle = function ChatToggle() {
  var countUnreadMessages = (0, _reactSdk.useHMSStore)(_reactSdk.selectUnreadHMSMessagesCount);
  var isChatOpen = (0, _useSidepane.useIsSidepaneTypeOpen)(_constants.SIDE_PANE_OPTIONS.CHAT);
  var toggleChat = (0, _useSidepane.useSidepaneToggle)(_constants.SIDE_PANE_OPTIONS.CHAT);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
    title: "".concat(isChatOpen ? "Close" : "Open", " chat"),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      onClick: toggleChat,
      active: !isChatOpen,
      "data-testid": "chat_btn",
      children: countUnreadMessages === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChatIcon, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChatUnreadIcon, {
        "data-testid": "chat_unread_btn"
      })
    })
  }, "chat");
};
exports.ChatToggle = ChatToggle;